import React, { Component } from 'react';
import './style.less';
import { Icon, Row, Col } from 'antd';
import WalletCard from './walletCard.tsx';
import { getWalletList } from '@/api/wallet';
import { sum } from '@/utils/tools';
import { getIsRedPacketVip } from '../../../api/recharge';

const clsPrefix = 'walletListCard';

const getAmtWithdraw = wallet => wallet.amtWithdraw;

class WalletListCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            walletList: [],
            isVip: false
        }
        this.fetchWalletList = this.fetchWalletList.bind(this);
    }

    componentDidMount() {
        this.fetchWalletList()
        this.handleGetIsRedPacketVip()
    }

    fetchWalletList() {
        getWalletList().then(data => {
            this.setState(
                {
                    walletList: data,
                }
            )
        });
    }

    handleGetIsRedPacketVip = () => {
        getIsRedPacketVip().then(res => {
            if(res) {
                this.setState({isVip: res.vip})
            }
        });
    }

    get totalMoney() {
        return sum(this.state.walletList.map(getAmtWithdraw));
    }

    render(){

        const { walletList } = this.state; 

        return(
            <div className={clsPrefix}>
              <div className={`${clsPrefix}-title`}>钱包</div>
              <div className="balanceMessage">
                <span className="balanceTips">总余额：<span className="balanceMoney">{this.totalMoney}</span>元</span>
              </div>
              <div className="warmTips">
                <Icon className="warmTipsIcon" type="info-circle" theme="filled"/>
                <div className="warmTitle">温馨提示</div>
                <Row>
                    <Col span="13">
                        <div className="warmMessage">
                            <p>1. 仍处于交易中的金额，不可提现；</p>
                            <p>2. 平台将在次月20日处理您的提现申请，在此期间，发起提现申请的金额将处于冻结状态；</p>
                            <p>3. 礼物投票免费版单笔提现金额最低为 100 元，白金版和钻石版提现最低金额10 元；</p>
                            <p>4. 开放平台单笔提现金额最低为 10 元；</p>
                            <p style={{ fontWeight: '500', display: 'flex', }}>
                                <div>5.</div>
                                <span style={{ lineHeight: '26px', marginTop: '-5px' }}>
                                    &nbsp;钱包余额为税前收入，对于个人用户，我平台将按劳务报酬代缴个税后打款至个人账户；对于企业用户，我平台将对公打款全部金额至贵司公户，由企业用户自行处置收入及报税
                                </span>
                            </p>
                        </div>
                    </Col>
                    <Col span="11">
                        <div style={{ textAlign: 'center' }}>
                            <p style={{  marginBottom: '5px', marginLeft: '6px' }} >提现打款需要先关注快站服务公众号</p>
                            <img style={{ width: '120px' }} src="//pic.kuaizhan.com/g3/d9/a6/1ad5-dd6b-4eef-abde-bc68a715350c46" alt="" />
                        </div>  
                    </Col>
                </Row>
              </div>
              <div  className={`${clsPrefix}-cardList`}>
              {
                 walletList.map((wallet) => (
                    <WalletCard
                      isVip={this.state.isVip}
                      title={wallet.title}
                      amtAlready={wallet.amtAlready}
                      balance={wallet.balance}
                      amtWithdraw={wallet.amtWithdraw}
                      amtOnWay={wallet.amtOnWay}
                      type={wallet.businessType}
                      rechargeble={wallet.rechargeble}
                      showAmtAlready={wallet.showAmtAlready}
                      onRechargeSuccess={this.fetchWalletList}
                    />
                  ))
              }
              {
                  walletList.length === 0 && <p style={{ textAlign: 'center' }}>暂无钱包</p>
              }
              </div>
            </div>
        );
    }
}
export default WalletListCard;